export const ErrorCodes = {
    AUTH_INVALID_CREDENTIALS: 'AUTH_INVALID_CREDENTIALS',
    AUTH_EMAIL_TAKEN: 'AUTH_EMAIL_TAKEN',
    AUTH_TOKEN_EXPIRED: 'AUTH_TOKEN_EXPIRED',
    AUTH_TOKEN_INVALID: 'AUTH_TOKEN_INVALID',
    AUTH_REFRESH_TOKEN_INVALID: 'AUTH_REFRESH_TOKEN_INVALID',
    AUTH_UNAUTHORIZED: 'AUTH_UNAUTHORIZED',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    ORG_NOT_FOUND: 'ORG_NOT_FOUND',
    ORG_SLUG_TAKEN: 'ORG_SLUG_TAKEN',
    ORG_FORBIDDEN: 'ORG_FORBIDDEN',
    ORG_MEMBER_EXISTS: 'ORG_MEMBER_EXISTS',
    ORG_PUBLIC_CHANNELS_DISABLED: 'ORG_PUBLIC_CHANNELS_DISABLED',
    INVITE_NOT_FOUND: 'INVITE_NOT_FOUND',
    INVITE_INVALID: 'INVITE_INVALID',
    INVITE_EXPIRED: 'INVITE_EXPIRED',
    INVITE_EXHAUSTED: 'INVITE_EXHAUSTED',
    CHANNEL_NOT_FOUND: 'CHANNEL_NOT_FOUND',
    CHANNEL_FORBIDDEN: 'CHANNEL_FORBIDDEN',
    CHANNEL_MEMBER_EXISTS: 'CHANNEL_MEMBER_EXISTS',
    MESSAGE_NOT_FOUND: 'MESSAGE_NOT_FOUND',
    // A send, edit or upload was encrypted under a key epoch that a departed member
    // still holds. The client must fetch the new epoch key and retry.
    KEY_EPOCH_SUPERSEDED: 'KEY_EPOCH_SUPERSEDED',
    MESSAGE_FORBIDDEN: 'MESSAGE_FORBIDDEN',
    TODO_LIST_NOT_FOUND: 'TODO_LIST_NOT_FOUND',
    TODO_NOT_FOUND: 'TODO_NOT_FOUND',
    TODO_FORBIDDEN: 'TODO_FORBIDDEN',
    // POST /users/consent: the submitted version is not the currently active
    // PRIVACY_POLICY_VERSION (stale client bundle). Distinct from VALIDATION_ERROR
    // so clients can reload rather than show a form error.
    CONSENT_VERSION_STALE: 'CONSENT_VERSION_STALE',
    BOT_NOT_FOUND: 'BOT_NOT_FOUND',
    BOT_FORBIDDEN: 'BOT_FORBIDDEN',
    BOT_KEY_INVALID: 'BOT_KEY_INVALID',
    // 426: the client is older than the server's configured minimum version
    // (MIN_CLIENT_VERSION_*). Clients show a blocking "update required" screen.
    CLIENT_UPDATE_REQUIRED: 'CLIENT_UPDATE_REQUIRED',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    // Generic codes the error middleware maps database-driver errors onto when
    // no aggregate-specific code applies (e.g. a unique-constraint violation
    // surfacing from a race the service did not pre-check).
    CONFLICT: 'CONFLICT',
    NOT_FOUND: 'NOT_FOUND',
    DATABASE_UNAVAILABLE: 'DATABASE_UNAVAILABLE',
};
//# sourceMappingURL=errors.js.map